import React from 'react'
import styles from './index.module.css'
import { VmsButton } from '@/components/vms-components/button'
import { useRouter } from 'next/router';

const ExclusiveBenefits = ({
  isMobile,
  isVisa,
  isActivePlan,
  benefits = []
}) => {
  // if (!benefits.length) return null
  const router = useRouter();
  const BENEFIT_ICONS = [
    {
      iconClass: styles.benefits_card_icon_globe,
      img: '/images/globe.svg',
    },
    {
      iconClass: styles.benefits_card_icon_activity,
      img: '/images/benefit-discount.svg',
    },
    {
      iconClass: styles.benefits_card_icon_calendar,
      img: '/images/benefit-calender.svg',
    },
    {
      iconClass: styles.benefits_card_icon_shield,
      img: '/images/bb-benefit-logo.svg',
    },
  ]

  const benefitsContainerClass = window.location.pathname.includes('/visa')
    ? styles.benefits_container_visa
    : styles.benefits_container

  return (
    <>
      {/* DESKTOP */}
      {!isMobile ? (
        <div className={styles.benefit_main}>
          {!isActivePlan && (
            <div className={styles.benefits}>
              <div className={benefitsContainerClass}>
                <div className={styles.benefits_header}>
                  <div className={`${styles.benefits_line} ${styles.benefits_line_left}`} />
                  <div className={styles.benefits_title_wrapper}>
                    <h2 className={styles.benefits_title}>
                      Exclusive BB-Pass benefits
                    </h2>
                  </div>
                  <div className={`${styles.benefits_line} ${styles.benefits_line_right}`} />
                </div>

                <div className={styles.benefits_grid}>
                  {benefits?.map((benefit, index) => {
                    const icon = BENEFIT_ICONS[index] || BENEFIT_ICONS[0]

                    return (
                      <div className={styles.benefits_card} key={benefit.id ?? index}>
                        <div className={`${styles.benefits_card_icon} ${icon.iconClass}`}>
                          <img src={icon.img} alt="membership_icon" />
                        </div>

                        <div className={styles.benefits_card_text}>
                          {benefit}
                        </div>
                      </div>
                    )
                  })}


                </div>
              </div>

              {isVisa && (
                <div className={styles.explore_features} onClick={() => router?.push('/membership')}>
                  <VmsButton>View Plan Features</VmsButton>
                </div>
              )}
            </div>
          )}
        </div>
      ) : (
        /* MOBILE */
        <>
          {isVisa ? (
            <div className={benefitsContainerClass} onClick={() => router?.push('/membership')}>
              <VmsButton>
                View Plan Features <img src="images/bv_right.svg" />
              </VmsButton>
            </div>
          ) : (
            <div className={benefitsContainerClass}>
              <div className={styles.benefits_header}>
                <div className={`${styles.benefits_line} ${styles.benefits_line_left}`} />
                <div className={styles.benefits_title_wrapper}>
                  <h2 className={styles.benefits_title}>
                    Exclusive BB-Pass benefits
                  </h2>
                </div>
                <div className={`${styles.benefits_line} ${styles.benefits_line_right}`} />
              </div>

              <div className={styles.benefits_grid}>
                {benefits?.map((benefit, index) => (
                  <div className={styles.benefits_card} key={benefit.id ?? index}>
                    <div className={styles.benefits_card_text}>
                      {benefit}
                    </div>
                  </div>
                ))}

              </div>
            </div>
          )}
        </>
      )}
    </>
  )
}

export default ExclusiveBenefits
